import * as React from 'react';
import {PureComponent} from 'react';
import {Container} from 'reactstrap';
import Form from './components/SubAntipyreticForm';
import Table from './components/SubAntipyreticTable';

//redux
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Panel from "../_commonComponents/Panel";
import {ADD, GET, SUBJECT_HOME_PATH} from "../../config/constants";
import {getObjectData} from "../../utils/getObjectData";
import {reset} from 'redux-form';
import {fetchAntipyreticData} from "../../redux/actions/subjectSymp/subjectAntipyreticAction";

/**
 * SubAntipyreticProps Прием жаропонижающего препарата '/subject/antipyretic'
 */
class SubAntipyretic extends PureComponent {
    state = {
        data: null
    };

    componentDidMount() {
        this.getInitialData();
    }

    redirect = () => {
        this.props.history.push(SUBJECT_HOME_PATH)
    };

    getInitialData = async () => {
        const {
            fetchAntipyreticData
        } = this.props;

        await fetchAntipyreticData(GET);
        this.setState({
            data: this.props.data
        })
    };

    /**
     * onSubmit
     * @param values {Object}
     */
    onSubmit = async (values) => {
        const {
            fetchAntipyreticData,
            reset
        } = this.props;

        await fetchAntipyreticData(ADD, values, [], false);

        this.setState({
            data: [...this.state.data, this.props.formData]
        }, () => {
            reset('sub_antipyretic_form')
        })
    };

    render() {
        const {
            data
        } = this.state;

        const {
            start,
            end,
            startText,
            endText
        } = this.props;

        return (
            <Container style={{maxWidth: 1000}} className="pt-2 pb-2">
                <Panel title={"Прием жаропонижающего препарата"} header>
                    <Form
                        onSubmit={this.onSubmit}
                        redirect={this.redirect}
                        start={start}
                        end={end}
                        startText={startText}
                        endText={endText}
                    />
                    {(data && data.length !== 0) &&  <Table
                        data={data}
                    />}
                </Panel>
            </Container>
        )
    }
}

const mapStateToProps = (store) => ({
    data: getObjectData(() => store.antipyreticData.data.data) || [],
    formData: getObjectData(() => store.antipyreticData.formData),
    start: getObjectData(() => store.profile.data.period.date_begin),
    end: getObjectData(() => store.profile.data.period.date_end),
    startText: getObjectData(() => store.profile.data.period.date_begin_text),
    endText: getObjectData(() => store.profile.data.period.date_end_text),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAntipyreticData,
    reset
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SubAntipyretic);
